export const SERVICE_ORDERING = "/new-order";
export const SELECT_APPOINTMENT = "/select-appointment/:id";
